module.exports = __webpack_public_path__ + "static/media/reward_activities.6dd96074.png";